(function(){
  if (window.__bvPredictiveHotfix2) return;
  window.__bvPredictiveHotfix2 = true;

  var SELECTOR = '#Search-In-Modal, input[type="search"]';

  function debounce(fn, wait){
    var t;
    return function(){
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function(){ fn.apply(ctx, args); }, wait);
    };
  }

  function init(){
    var el = document.querySelector(SELECTOR);
    if (!el) return setTimeout(init, 300);

    // block the heavy handler before it runs, keep caret intact
    function block(e){
      e.stopImmediatePropagation();
      relay();
    }

    var relay = debounce(function(){
      // temporarily unhook our blocker so the theme's handlers can run once
      el.removeEventListener('input', block, true);
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.addEventListener('input', block, true);
    }, 200); // try 200 first, then 150 if it feels slow

    // capture phase so we run before the theme
    el.addEventListener('input', block, true);
  }

  init();
})();
